import { MenuItemType } from '@utils/types'
import { A11y } from 'swiper/modules'
import { SwiperSlide } from 'swiper/react'
import { useTrans } from '../../../hooks'
import { Chip, WContainer } from '../../atoms'
import GenericSlider from '../GenericSlider/GenericSlider'
import styles from './ChipsBarResults.module.sass'
import { CategoriaNode } from '@gql/graphql'

interface Props {
  categorie: any[] // Categorie Magazine
  className?: string
  selectedChip?: any // Categoria Magazine
  setSelectedChip?: (v: number | string) => void
  results?: number
}

const ChipsBarResults = (props: Props) => {
  const {
    categorie = [],
    className = '',
    selectedChip = undefined,
    setSelectedChip,
    results = undefined,
  } = props

  const t = useTrans()

  return (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={`${styles.layout}`}>
          {!!categorie?.length && (
            <div className={styles.slider}>
              <GenericSlider
                conf={{
                  modules: [A11y],
                  spaceBetween: 8,
                  slidesPerView: 'auto',
                  breakpoints: {
                    1024: {
                      spaceBetween: 16,
                    },
                  },
                }}
              >
                <SwiperSlide>
                  <Chip
                    label={t('Tutte le categorie')}
                    selected={selectedChip === null}
                    className={styles.chip}
                    onClick={() => setSelectedChip(null)}
                  />
                </SwiperSlide>
                {categorie.map((i) => (
                  <SwiperSlide key={i.pk}>
                    <Chip
                      key={i.pk}
                      label={i.title}
                      selected={selectedChip?.pk === i.pk}
                      className={styles.chip}
                      onClick={() => setSelectedChip(i)}
                    />
                  </SwiperSlide>
                ))}
              </GenericSlider>
            </div>
          )}
          <p className={styles.results}>
            {t(`{0} ${results === 1 ? 'risultato' : 'risultati'}`, [
              (results > 0 ? results : 0).toString(),
            ])}
          </p>
        </div>
      </WContainer>
    </div>
  )
}

export default ChipsBarResults
